module.exports = __webpack_public_path__ + "img/SES_235250019.25938901.jpg";